function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Log from '@deephaven/log';
var log = Log.module('PouchCommandHistoryCache');

/**
 * Cache for tracking things shared across multiple
 * `PouchCommandHistoryTable` instances.
 */
class PouchCommandHistoryCache {
  constructor() {
    /**
     * Keep track of pruning status for a database. This helps ensure only 1
     * pruning operation gets executed if multiple instances of a PouchCommandHistory
     * table load data at the same time.
     */
    _defineProperty(this, "isPruning", void 0);
    /**
     * Cache for command history query results keyed by db name. The cached data
     * will be shared across all `PouchCommandHistoryTable` instances that have
     * the same db name.
     */
    _defineProperty(this, "response", void 0);
    /**
     * Keeps track of all `PouchCommandHistoryTable` instances.
     */
    _defineProperty(this, "tableRegistry", void 0);
    this.isPruning = new Map();
    this.response = new Map();
    this.tableRegistry = new Map();
  }
  /**
   * Pauses PouchDB change listeners for any `PouchCommandHistoryTable` with
   * the given database name. This will cancel existing subscriptions and
   * return a callback that can be used to re-subscribe them.
   * @param dbName
   */
  pauseChangeListeners(dbName) {
    var _this$tableRegistry$g;
    var pausedTables = [];
    (_this$tableRegistry$g = this.tableRegistry.get(dbName)) === null || _this$tableRegistry$g === void 0 || _this$tableRegistry$g.forEach(table => {
      if (table.changes) {
        log.debug("Pausing event listeners on '".concat(dbName, "' table"), table);
        table.changes.cancel();
        pausedTables.push(table);
      }
    });
    return () => {
      pausedTables.forEach(table => {
        var _this$tableRegistry$g2, _this$tableRegistry$g3;
        // Resume listening for changes if the table is still in the registry
        if ((_this$tableRegistry$g2 = (_this$tableRegistry$g3 = this.tableRegistry.get(dbName)) === null || _this$tableRegistry$g3 === void 0 ? void 0 : _this$tableRegistry$g3.has(table)) !== null && _this$tableRegistry$g2 !== void 0 ? _this$tableRegistry$g2 : false) {
          log.debug("Resuming event listeners on '".concat(dbName, "' table"), table);
          table.listenForChanges();
        }
      });
    };
  }
}
export default PouchCommandHistoryCache;
//# sourceMappingURL=PouchCommandHistoryCache.js.map